export default __webpack_public_path__ + "static/sportmaster-ea86c32eb41912c445dafcefb283f8d9.png";